<template>
  <div class="business-wrap" v-animate-on-scroll="'animate__fadeInUp'">
    <img src="@/assets/images/icon-2.png" alt="" class="icon-image" />
    <template v-if="!isMobile">
      <div class="tab-list">
        <div
          class="item"
          :class="{
            active: currentTab.categoryCode == item.categoryCode
          }"
          v-for="(item, index) in businessSectorList"
          :key="index"
          @click="handleTabClick(item, index)"
        >
          <img class="img" :src="getIconUrl(item)" alt="logo" />
          <div class="name">{{ item.categoryName }}</div>
        </div>
      </div>
      <div class="company-row" v-if="currentTab">
        <div class="company-lt">
          <div class="lt-title">
            <div class="title-tip">
              {{ currentTab.contArticle.articleName }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="9"
                viewBox="0 0 20 9"
                fill="none"
                class="title-icon"
              >
                <path
                  d="M10.669 8.39793C10.2887 8.74021 9.71134 8.74021 9.33103 8.39793L0 0L20 0L10.669 8.39793Z"
                  fill="#1B56A9"
                />
              </svg>
            </div>
            <div class="title-hr"></div>
          </div>
          <div
            class="lt-item"
            v-html="currentTab.contArticle.articleContent"
          ></div>
          <div class="more-btn" @click="handleBusiness(currentTab)">
            查看所有服务>>
          </div>
        </div>
        <div class="company-rt">
          <img class="image" :src="currentTab.contArticle.cover" alt="logo" />
        </div>
      </div>
    </template>
    <!-- 手机端 -->
    <div class="swiper-container" id="swiper1" v-else>
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in businessSectorList"
          :key="index"
        >
          <img class="img" :src="getIconUrl(item)" alt="logo" />
          <div class="slide-title">{{ item.categoryName }}</div>
          <div
            class="slide-message"
            v-html="item.contArticle.articleContent"
          ></div>
          <img class="image" :src="item.contArticle.cover" alt="logo" />
          <div class="footer-title" @click="handleBusiness(currentTab)">
            查看所有服务>>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getChildernList } from '@/api/home/home.js'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      businessSectorList: null,
      currentTab: null,
      currentIndex: 0,
      intervalId: null
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile // 假设 isMobile 在根 state 下
    })
  },
  watch: {
    isMobile(newVal) {
      if (newVal) {
        // 切换到移动端，初始化 swiper
        clearInterval(this.intervalId)
        this.mobileSwiper()
      } else {
        clearInterval(this.intervalId)
        // 切换到PC端，启动动画
        this.startAnimationLoop()
      }
    }
  },
  created() {
    this.getBusinessList(104)
  },
  mounted() {
    if (!this.isMobile) {
      this.startAnimationLoop()
    } else {
      this.$nextTick(() => {
        this.mobileSwiper()
      })
    }
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    clearInterval(this.intervalId)
  },
  methods: {
    getBusinessList(id) {
      getChildernList(id).then((res) => {
        if (!res.data) return
        this.businessSectorList = res.data
        this.currentTab = this.businessSectorList[0]
        // 数据加载后初始化swiper
        if (this.isMobile) {
          this.$nextTick(() => {
            this.mobileSwiper()
          })
        }
      })
    },
    startAnimationLoop() {
      this.triggerAnimation() // 立即播放一次
      this.intervalId = setInterval(() => {
        this.triggerAnimation()
      }, 5000) // 每5秒触发一次
    },
    triggerAnimation() {
      if (this.businessSectorList) {
        this.currentIndex =
          (this.currentIndex + 1) % this.businessSectorList.length
        this.currentTab = this.businessSectorList[this.currentIndex]
      }
    },
    handleTabClick(item, index) {
      this.currentIndex = index
      this.currentTab = item
    },
    handleBusiness(currentTab) {
      let url =
        '/tabList?categoryId=' +
        currentTab.categoryCode +
        '&linkType=' +
        currentTab.linkType +
        '&tabcode=104&seccode=' +
        currentTab.categoryCode +
        '&id=' +
        currentTab.linkUrl
      this.$router.push(url)
    },
    getIconUrl(item) {
      // 技能提升使用本地图片
      if (item.categoryName === '技能提升') {
        return require('@/assets/images/icon-35.png')
      }
      // 其他使用接口返回的iconUrl
      return item.iconUrl
    },
    mobileSwiper() {
      if (!this.businessSectorList || this.businessSectorList.length === 0)
        return
      new Swiper('#swiper1', {
        direction: 'horizontal',
        speed: 2000,
        loop: true,
        autoplay: true,
        observer: true,
        observeParents: true,
        effect: 'coverflow',
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        coverflowEffect: {
          rotate: 0,
          stretch: -4,
          depth: 15,
          modifier: 1.5,
          slideShadows: false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.business-wrap {
  display: flex;
  flex-direction: column;
  width: 1340px;
  margin: 64px auto 120px;
  .company-row {
    display: flex;
    flex-direction: row;
    margin-top: 34px;
    min-height: 407px;
    .company-rt {
      width: 702px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .image {
        width: 702px;
        height: 407px;
        object-fit: cover;
        margin: auto 0;
      }
    }
    .company-lt {
      flex: 1;
      margin-right: 34px;
      display: flex;
      flex-direction: column;
      .more-btn {
        margin-top: 31px;
        background: #1b56a9;
        width: 201px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        font-size: 24px;
        color: #fff;
        font-weight: 500;
        cursor: pointer;
      }
      .lt-item {
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        color: #333;
        font-size: 20px;
        line-height: 40px;
        margin-top: 14px;
        font-weight: 500;
      }
      .lt-title {
        display: flex;
        flex-direction: row;
        height: 56px;
        .title-hr {
          background: #e6e6e6;
          height: 1px;
          flex: 1;
          margin-top: auto;
          margin-bottom: 9px;
        }
        .title-tip {
          display: flex;
          flex-direction: column;
          min-width: 127px;
          text-align: center;
          background: #1b56a9;
          height: 47px;
          line-height: 47px;
          font-size: 24px;
          font-weight: 600;
          color: #fff;
          position: relative;
          .title-icon {
            width: 20px;
            height: 9px;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            bottom: -9px;
          }
        }
      }
    }
  }
  .tab-list {
    border-radius: 8px;
    background: linear-gradient(180deg, #e7f2ff 0%, #fff 128.79%);
    padding: 20px 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    border-radius: 8px;
    .item {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 125px;
      cursor: pointer;
      color: #333;
      .img {
        width: 80px;
        height: 80px;
        position: relative;
        left: 5px;
      }
      .name {
        font-size: 16px;
      }
    }
    .active {
      border-radius: 6px;
      background: #d9e8ff;
      color: #1b56a9;
    }
  }
  .icon-image {
    width: 250px;
    height: 64px;
    margin: 0 auto 34px;
  }
}

// 手机端css
.mobile-content {
  .business-wrap {
    width: 375px;
    margin: 32px auto 60px;
    // 轮播图
    .swiper-container {
      width: 100%;
      display: flex;
      flex-direction: row;
      .swiper-slide {
        width: 295px !important;
        // height: 120px;
        font-size: 14px;
        text-align: center;
        border-radius: 8px;
        position: relative;
        border-radius: 4px;
        background: linear-gradient(180deg, #e7f2ff 0%, #fff 128.79%);
        display: flex;
        flex-direction: column;
        .footer-title {
          display: flex;
          flex-direction: row;
          justify-content: center;
          color: #1b56a9;
          font-size: 14px;
          margin-bottom: 20px;
        }
        .image {
          width: 265px;
          height: 180px;
          margin: 20px auto;
          border-radius: 4px;
          object-fit: cover;
        }
        .slide-message {
          font-size: 15px;
          line-height: 24px !important;
          padding: 0 15px;
          margin-top: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }
        .slide-title {
          font-size: 20px;
          color: #333;
          height: 30px;
          line-height: 30px;
          font-weight: bold;
        }
        .img {
          width: 50px;
          height: 50px;
          margin: 20px auto 10px;
        }
      }

      .bookImg {
        width: 335px !important;
        height: 120px;
        border-radius: 8px;
      }
    }
    .icon-image {
      width: 150px;
      height: 38.4px;
    }
  }
}
</style>
